'use strict';

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (value) {
  if (Array.isArray(value)) value = value.join(',');
  return value.match(/-webkit-|-moz-|-ms-/) !== null;
};

module.exports = exports['default'];